/**
 * Check whether a Form Schema field declares a usable default source.
 *
 * `undefined` intentionally means that no default was declared. Other
 * falsy values, including `false`, `0`, an empty string, and `null`, remain
 * valid defaults.
 */
export function hasFormSchemaDefault<TValue>(
	field: { default?: TValue },
): field is { default: TValue & (NonNullable<unknown> | null) } {
	return field.default !== undefined;
}
